
import {
  ProductCatalogDto,
  CreateProductCatalogDto,
  UpdateProductCatalogDto,
  ProductType,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { axios, PaginatedQueryBase } from './api'
import { PaginatedDto } from './extendedType'

export type ProductCatalogsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
  type?: ProductType
  genericName?: string
  supplierId?: string
  excludedIds?: string[]
  checkOrderExamAssociation?: boolean
}

class ProductCatalogService extends BaseCrudService<
  ProductCatalogDto,
  CreateProductCatalogDto,
  UpdateProductCatalogDto,
  ProductCatalogsFilters
> {
  constructor() {
    super('product-catalog', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }

  getAllGenericNames(search?: string): Promise<PaginatedDto<string>> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/generic-names`, undefined, { search })
      axios(configs, resolve, reject)
    })
  }
}

export const productCatalogService = new ProductCatalogService()
